import { PageRoutes } from "@/app/components/router/routes";
import { FileType } from "../../constants/misc/FileType";
import useExportToFile from "../../utils/useExportToFile";
import { ApiRoutes } from "../apiRoutes";
import { brGet } from "../brRequestWrapper";
import { useQuery } from "react-query";
import { InvoicesPastDueResponse } from "@/app/features/InvoiceBillingReminder/billingReminder.types";

export interface InvoicesPastDueRequest {
  pageSize: number,
  isCsv: boolean,
  cursor?: number
}

const { exportFile } = useExportToFile();

export const getInvoicesPastDueCSV = async () => {
  const requestConfig = {
    headers: {
      "api-version": "2.0",
    },
  };
  const path = ApiRoutes.PastDueInvoices;
  const request = `${path}?iscsv=${true}`;
  const response = await brGet(request, requestConfig);

  await exportFile("BillingReminder", response.data, FileType.Csv);
  return response.data;
};

export const useGetInvoicesPastDueV2 = (request: InvoicesPastDueRequest) => useQuery({
  queryKey: ["invoices-past-due-v2", request.pageSize, request.isCsv, request.cursor],
  enabled: false,
  queryFn: async (): Promise<InvoicesPastDueResponse> => {
    const requestConfig = {
      headers: {
        "api-version": "2.0",
      },
    };
    const route = `${ApiRoutes.PastDueInvoices}?pageSize=${request.pageSize}&isCsv=${request.isCsv}` + (request.cursor ? `cursor=${request.cursor}`: '');

    try {
      const response = await brGet(
        route,
        requestConfig
      );
      return response.data;
    } catch (error: any) {
      // Return empty data for 400 errors (no data available)
      if (error.response?.status === 400) {
        return {
          items: [],
          pageSize: 10,
          totalCount: 0,
          hasMore: false
        };
      }
      // All other errors (including auth) are handled by brRequestWrapper
      window.location.replace(PageRoutes.AUTH_ERROR);
      throw error;
    }
  }
})
